import React, { memo } from 'react';
import { t } from 'ttag';
import { formGroup, formControl, FormDataType } from '@core/utils/form';
import { FormInput, FormContainer } from '@core/components/form';
import { FCItemControlProps } from '../FCItem';
import { FCType } from './types';
import { R } from '@core/utils/r';

export function defineFunctionForm() {
  const form = formGroup({
    id: formControl<number>({ initialValue: R.random(0, 10000) }),
    type: formControl<FCType>({ initialValue: FCType.function }),
    title: formControl<string>({
      label: t`Title`,
      required: true,
      initialValue: t`Title`,
    }),
  });

  return form;
}

export type FCFunctionFormData = FormDataType<typeof defineFunctionForm>;
export type FCFunctionForm = ReturnType<typeof defineFunctionForm>;

export interface FCTextProps extends FCItemControlProps {
  form: FCFunctionForm;
}

export const FCFunction = memo((props: FCTextProps) => {
  const { form } = props;

  return (
    <FormContainer onSubmit={form.submit}>
      <div className="p-3">
        <FormInput control={form.controls.title} />
      </div>
    </FormContainer>
  );
});
